import { Store, ActionTree, ActionContext } from 'vuex'
import { State } from './state'
import { StatsUruchomieniaService } from "@/services/stats-uruchomienia.service";
import { DataTablePaginatorAndProduct } from "@/store/modules/dashboard/types";
import { ProductIdAndLastYear, ForceUpdateAndLastYear } from "@/pitprojekt/types";
import _ from 'lodash'

export async function updateAggregatedStatsUruchomieniaSum(store: ActionContext<State, any>, params: ForceUpdateAndLastYear) {
    store.commit('updatingAggregatedStatsUruchomieniaSum', params.forceUpdate);

    for (let index in store.rootState.SettingsModule.selectedProducts) {
        let productId: number = store.rootState.SettingsModule.selectedProducts[index];

        if (_.find(store.state.aggregatedStatsUruchomieniaSumBuffer, function(o) { return o.productId == productId; }) == undefined) {
            store.dispatch('getAggregatedStatsUruchomieniaSumBetweenDatesForProduct', {'productId': productId, 'lastYear': params.lastYear});
        }
        else
            store.commit('updatedAggregatedStatsUruchomieniaSum');
    }

}

export async function getAggregatedStatsUruchomieniaSumBetweenDatesForProduct(store: ActionContext<State, any>, params: ProductIdAndLastYear) {
    try {
        const aggregatedStatsUruchomienia = await StatsUruchomieniaService.getAggregatedSumBetweenDates(params.productId, store.rootState.SettingsModule.dateFrom, store.rootState.SettingsModule.dateTo, params.lastYear);
        store.commit('loadedAggregatedStatsUruchomieniaSumForProduct', {'productId': params.productId, 'stat': aggregatedStatsUruchomienia.sum});
        if (store.state.aggregatedStatsUruchomieniaSumBuffer.length === store.rootState.SettingsModule.selectedProducts.length) {
            store.commit('updatedAggregatedStatsUruchomieniaSum');
        }
        return true;
    }
    catch (error) {
        return false;
    }
}


export async function getAggregatedStatsUruchomieniaBetweenDatesForProduct(store: ActionContext<State, any>,  paginator: DataTablePaginatorAndProduct) {
    store.commit('loadingAggregatedStatsUruchomieniaBetweenDatesForProduct');
    try {
        const aggregatedStatsUruchomienia = await StatsUruchomieniaService.getAggregatedBetweenDates(paginator.page, paginator.itemsPerPage, store.rootState.SettingsModule.dateFrom, store.rootState.SettingsModule.dateTo, paginator.lastYear, false, paginator.productId);
        store.commit('loadedAggregatedStatsUruchomieniaForProduct', {data: aggregatedStatsUruchomienia.data.data, currentPage: aggregatedStatsUruchomienia.data.current_page, total: aggregatedStatsUruchomienia.data.total});

        return true;
    }
    catch (error) {
        return false;
    }
}

export async function getDetailedStatsUruchomieniaBetweenDatesForProduct(store: ActionContext<State, any>,  params: ProductIdAndLastYear) {
    store.commit('loadingDetailedStatsUruchomieniaBetweenDatesForProduct');
    try {
        const detailedStatsUruchomienia = await StatsUruchomieniaService.getDetailedListBetweenDates(params.productId, store.rootState.SettingsModule.dateFrom, store.rootState.SettingsModule.dateTo, params.lastYear);
        store.commit('loadedDetailedStatsUruchomieniaForProduct', detailedStatsUruchomienia);

        return true;
    }
    catch (error) {
        return false;
    }
}


export default <ActionTree<State, any>> {
    updateAggregatedStatsUruchomieniaSum, getAggregatedStatsUruchomieniaSumBetweenDatesForProduct, getAggregatedStatsUruchomieniaBetweenDatesForProduct, getDetailedStatsUruchomieniaBetweenDatesForProduct
}
